// extracted by mini-css-extract-plugin
module.exports = {"svgLogo":"_2C9oSJ","shine-lines":"_328tsg"};